"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TYPES = exports.TITLES = exports.SUBTYPES = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../../../constants");
var _excluded = ["disabled", "subtype", "type", "id", "suffix"];
var _TITLES;
var TYPES = exports.TYPES = _constants.TICKET_TYPES;
var SUBTYPES = exports.SUBTYPES = {
  NEW: 'new',
  REFUSAL: 'refusal',
  ORDER: 'order',
  CANCELATION: 'cancelation',
  TOUR: 'tour',
  EXTRAS: 'extras',
  CONFLICT: 'conflict',
  RESTING: 'in_resting'
};
var TITLES = exports.TITLES = (_TITLES = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_TITLES, TYPES.COMMON_QUESTION, 'Общие воп.'), TYPES.TOUR_SELECTION, 'Подбор тура'), TYPES.UNKNOWN, 'Нет типа'), TYPES.UPDATING, 'Изменение'), TYPES.HOTLINE, 'Горячая лин.'), SUBTYPES.NEW, 'Новый'), SUBTYPES.REFUSAL, 'По отказу'), SUBTYPES.ORDER, 'Заказа'), SUBTYPES.CANCELATION, 'Аннуляция'), SUBTYPES.TOUR, 'По туру'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_TITLES, SUBTYPES.EXTRAS, 'Доп услуги'), SUBTYPES.CONFLICT, 'Конфликт'), SUBTYPES.RESTING, 'На отдыхе'));
var TicketType = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var isDisabled = _ref.disabled,
    subtype = _ref.subtype,
    type = _ref.type,
    id = _ref.id,
    suffix = _ref.suffix,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var typeTitle = TITLES[type];
  var subtypeTitle = TITLES[subtype];
  var label = id && "\u0422\u0438\u043A\u0435\u0442 ".concat(id) || type !== TYPES.UNKNOWN && subtypeTitle;
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, (0, _extends2["default"])({}, props, {
    disabled: isDisabled,
    type: type
  }), /*#__PURE__*/_react["default"].createElement(StyledType, {
    disabled: isDisabled,
    type: type
  }, typeTitle), label && /*#__PURE__*/_react["default"].createElement(StyledLabel, null, label), suffix);
});
TicketType.displayName = 'TicketType';
TicketType.propTypes = {
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  subtype: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(Object.values(TYPES)),
  suffix: _propTypes["default"].node
};
TicketType.defaultProps = {
  className: '',
  id: null,
  disabled: false,
  subtype: '',
  type: TYPES.UNKNOWN,
  suffix: null
};
var StyledType = _styledComponents["default"].div.withConfig({
  displayName: "TicketType__StyledType",
  componentId: "sc-1sorszo-0"
})(["border-radius:23px;color:#fff;height:100%;height:23px;line-height:22px;overflow:hidden;padding:0 10px;text-align:center;text-overflow:ellipsis;white-space:nowrap;width:103px;", " ", " ", " ", " ", " ", ""], function (_ref2) {
  var type = _ref2.type;
  return type === TYPES.UPDATING && "\n    background-image: linear-gradient(to right, #35dad8, #1b58e2);\n  ";
}, function (_ref3) {
  var type = _ref3.type;
  return type === TYPES.TOUR_SELECTION && "\n    background-image: linear-gradient(to left, #dd3d3d, #a521ab);\n  ";
}, function (_ref4) {
  var type = _ref4.type;
  return type === TYPES.COMMON_QUESTION && "\n    background-image: linear-gradient(to left, #008bcf, #9e4de3);\n  ";
}, function (_ref5) {
  var type = _ref5.type;
  return type === TYPES.HOTLINE && "\n    background-image: linear-gradient(270deg, #DD9D3D 0%, #F01C0E 100%);\n  ";
}, function (_ref6) {
  var type = _ref6.type;
  return type === TYPES.UNKNOWN && "\n    background-color: #fff;\n    color: #919499;\n    line-height: 20px;\n  ";
}, function (_ref7) {
  var disabled = _ref7.disabled,
    type = _ref7.type;
  return disabled && type !== TYPES.UNKNOWN && "\n    background-color: #919499;\n    background-image: none;\n  ";
});
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "TicketType__StyledLabel",
  componentId: "sc-1sorszo-1"
})(["line-height:22px;padding:0 8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketType__StyledContainer",
  componentId: "sc-1sorszo-2"
})(["align-items:center;border-radius:23px;display:flex;font-size:14px;height:23px;width:100%;", " ", " ", " ", " ", " ", ""], function (_ref8) {
  var type = _ref8.type;
  return type === TYPES.UPDATING && "\n    background-image: linear-gradient(to right, #e5f4fb, #e3ebfc);\n  ";
}, function (_ref9) {
  var type = _ref9.type;
  return type === TYPES.TOUR_SELECTION && "\n    background-image: linear-gradient(to left, #fbe7e8, #f7e5f0);\n  ";
}, function (_ref10) {
  var type = _ref10.type;
  return type === TYPES.COMMON_QUESTION && "\n    background-image: linear-gradient(to left, #e1f0fa, #ebecfb);\n  ";
}, function (_ref11) {
  var type = _ref11.type;
  return type === TYPES.HOTLINE && "\n    background-image: linear-gradient(270deg, #FBF7E7 0%, #F7E5E5 61.33%);\n  ";
}, function (_ref12) {
  var type = _ref12.type;
  return type === TYPES.UNKNOWN && "\n      flex: 1;\n      border: 1px solid #919499\n      ".concat(StyledType, " {\n        color: white;\n        background: #919499;\n      }");
}, function (_ref13) {
  var disabled = _ref13.disabled,
    type = _ref13.type;
  return disabled && type !== TYPES.UNKNOWN && "\n    background-color: #d7d7d7;\n    background-image: none;\n  ";
});
TicketType.StyledSubtype = StyledLabel;
TicketType.StyledType = StyledType;
TicketType.TYPES = TYPES;
TicketType.SUBTYPES = SUBTYPES;
TicketType.TITLES = TITLES;
var _default = exports["default"] = TicketType;